/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMCookieDialogAcceptPayload } from '@/data/types/GTM';

export const getGTMCookieDialogAcceptEventData = async (payload: GTMCookieDialogAcceptPayload) => ({
	ad_storage: payload.ad_storage,
	analytics_storage: payload.analytics_storage,
	ad_user_data: payload.ad_user_data,
	ad_personalization: payload.ad_personalization,
});
